/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const FeedbackThreadsInitiallyCollapsedSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('FEEDBACK_THREADS_INITIALLY_COLLAPSED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class FeedbackThreadsInitiallyCollapsedSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FeedbackThreadsInitiallyCollapsedSettingParser.decode(input).map(res => new FeedbackThreadsInitiallyCollapsedSetting(res));
    }
    static unsafeDecode(input) {
        return FeedbackThreadsInitiallyCollapsedSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FeedbackThreadsInitiallyCollapsedSettingParser.encode(data);
    }
    static schema() {
        return FeedbackThreadsInitiallyCollapsedSettingParser.schema();
    }
}
